import React from 'react';
import PropTypes from 'prop-types';

import { Box, CircularProgress, Paper, TableContainer } from '@mui/material';
import produce from 'immer';

import { AutocompleteCustom, SelectCustom } from '../../../components/Inputs';
import localization from '../../../localization';
import { checkValue } from '../../../services/helpers/dataStructuring';
import InheritanceField from '../InheritanceField';
import PricesTable from './PricesTable/index';
import { checkDefaultCurrencyError } from './PricesTable/util';
import { ScheduledPricesTable } from './ScheduledPricesTable';

import './prices.scss';

const Prices = ({
  selectOptions,
  currentProductData,
  setProductData,
  parentId,
  scheduledPrices,
  setCurrentPrices,
  currentPrices,
  prices,
  setPriceFromSource,
  defCurrencyOptions,
}) => {
  const defaultCurrencyError = checkDefaultCurrencyError(currentProductData);

  const handleDefaultCurrencySelect = (e) => {
    const newValue = e.target.value;

    setProductData(
      produce((draft) => {
        draft.prices.defaultCurrency = newValue;
      }),
    );
  };

  if (!currentPrices) {
    return (
      <Box display='flex' justifyContent='center' mt={2}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Box px={2} className='product-prices' mb={2}>
        <TableContainer component={Paper}>
          <PricesTable
            setCurrentPrices={setCurrentPrices}
            currentPrices={currentPrices}
            prices={prices}
            currentProductData={currentProductData}
            setPriceFromSource={setPriceFromSource}
          />
        </TableContainer>
      </Box>
      <Box width={300} pt={4} px={2}>
        <SelectCustom
          hasError={defaultCurrencyError}
          helperText={defaultCurrencyError ? localization.t('errorNotifications.required') : ''}
          isRequired
          label='defaultCurrency'
          value={currentProductData?.prices?.defaultCurrency}
          selectOptions={defCurrencyOptions}
          onChangeSelect={handleDefaultCurrencySelect}
        />
      </Box>
      <Box width={300} p={2} pt={4}>
        <InheritanceField
          field='priceFunction'
          onChange={setProductData}
          value={currentProductData.priceFunction}
          selectOptions={selectOptions.priceFunctions || []}
          parentId={parentId}
          currentProductData={currentProductData}
        >
          <AutocompleteCustom
            optionLabelKey='value'
            label='priceFunction'
            onSelect={(newValue) =>
              setProductData({
                ...currentProductData,
                priceFunction: newValue,
              })
            }
            selectOptions={selectOptions?.priceFunctions || []}
            curValue={checkValue(currentProductData.priceFunction)}
          />
        </InheritanceField>
      </Box>
      {scheduledPrices.length > 0 && <ScheduledPricesTable scheduledPrices={scheduledPrices} />}
    </>
  );
};

Prices.propTypes = {
  selectOptions: PropTypes.object,
  setProductData: PropTypes.func,
  currentProductData: PropTypes.object,
  parentId: PropTypes.string,
  scheduledPrices: PropTypes.array,
  setCurrentPrices: PropTypes.func,
  currentPrices: PropTypes.array,
  prices: PropTypes.array,
  defCurrencyOptions: PropTypes.array,
  setPriceFromSource: PropTypes.func,
};

export default Prices;
